import React from 'react';
import Header from './header';
import Inventory from './inventory';
import Order from './order';
import samplefishes from '../sample-fishes';
import Fish from './fish';
import { toparams} from "./param";

class App extends React.Component
{   
    state={  //intial state, declaring in app.js so that the state can be shared to all header,inentory, orders and get updated at all places at once
        fishes:{}, //added fishes
        order:{}, //items added to cart
    };

    componentDidUpdate() //to store the order in local storage
    {
        const {params}=this.props;
        localStorage.setItem(this.props.params.storeId,JSON.stringify(this.state.order)); //using stringy because we need a string to be displayed not the object fish
    }

    componentDidMount()
    {    //reinstating the local storage, which gets triggered when component mounts and refreshes the local storage as well
        const {params}=this.props;
        const localStorageRef = localStorage.getItem(params.storeId);
        if (localStorageRef) {
          this.setState({ order: JSON.parse(localStorageRef) }); //ref is astring hence turning it into an object
        }
        
    }
    
    addfish=(fish)=>
    {
      const fishcopy={...this.state.fishes};   // 1.make a copy of existing state, to avoid mutation
      fishcopy[`fish${Date.now()}`]=fish;       //2.add our new fish to fishes variable //creating fish1,fish2,fish3..etc based on time
       this.setState(                            // 3.set the new fishes object to state
            {  
                fishes:fishcopy
            }
        );
    }
    
    loadSamples=()=>  //to load sample fishes
    {
        this.setState(
            {
                fishes:samplefishes
            }
        );
    };
    
    addtoorder=(key)=> //to enable add to cart
    {
        const ordercopy={...this.state.order};
        ordercopy[key]=ordercopy[key]+1||1;// if the item exists update it to +1 or add that item
        this.setState(
        {
            order:ordercopy
        }
        );
    }

    updateFish = (key, updatedFish) =>  //updating the details of existing fishes
    { 
        const fishescopy = { ...this.state.fishes };
       
        fishescopy[key] = updatedFish; //updating the fish with the updated details
       
        this.setState({ fishes:fishescopy });
    };

    deleteFish = key => 
    {
      const fishescopy = { ...this.state.fishes };
      
      delete fishescopy[key];
      
      this.setState({ fishes:fishescopy });
    };

    removeFromOrder = key => 
    {
        const ordercopy = { ...this.state.order };
        delete ordercopy[key];
        this.setState({ order:ordercopy });
    };

    render()
        {
            return(
                <div className='catch-of-the-day'>
                <div className='menu'>
                    <Header tagline="Fresh Sea Food"/>
                    <ul className='fishes'>
                    {/* //to loop over all the fishes and display it as alis under the header, gives keyvalue to each of the fish */ }
                     {Object.keys(this.state.fishes).map(key=><Fish key={key} details={this.state.fishes[key]} 
                     index={key} //giving a unique indentifier to each fish so that react works faster //to get the key we use index as variable because key is a keyword to react
                      addtoorder={this.addtoorder}></Fish>) //passing it as a prop to fish.js
                      } 
                     
                    </ul>
                </div>

                <Order 
                {...this.state} // passing the fishes and order object to order.js
                removeFromOrder={this.removeFromOrder}
                />

                <Inventory 
                addfish={this.addfish}   //to access the addfishform for fish object we need to go two level deep, thus add this addfish as a prop to inventory and then to addfishform.js to access the fishes object declared in the state
                updateFish={this.updateFish} 
                loadSamples={this.loadSamples} 
                deleteFish={this.deleteFish} 
                fishes={this.state.fishes}/> 
                {/* //to loop over all fishes to add them in Editfishform */}
                
            </div>
            );
        }
    
}

export default toparams(App); 